import { ExternalConnectionsProviders } from '@griply/types';

const googleProposeTimeUrl =
  'https://calendar.google.com/calendar/u/0/r/proposetime';

// Undocumented route — the fallback keeps an unkeyable event on its own page, where the RSVP menu offers the same action.
export const getCalendarEventProposeTimeUrl = (
  url: string | undefined,
  provider: ExternalConnectionsProviders,
): string | undefined => {
  if (!url || provider !== ExternalConnectionsProviders.Google) {
    return url;
  }

  const eid = url.split('?')[1]?.match(/(?:^|&)eid=([^&]+)/)?.[1];

  if (!eid) {
    return url;
  }

  return `${googleProposeTimeUrl}/${decodeURIComponent(eid)}`;
};
